const translations = {
    applicationDetails: 'Application Details',
    finalSubmitError: 'There was an error saving the product usage report',
    notes: 'Notes',
    productDetails: 'Product Details',
    submitFormError: 'There was an error creating your draft',
    submitReport: 'Submit Product Usage Report',
    title: 'New Product Usage Report'
};

export default translations;
